import { call } from 'redux-saga/effects';
import { apiRequest } from '../api/api.saga-services';
import * as api from '../api/request-config/support.api';
import * as dialogService from '../dialog/dialog.saga-services';
import { addFlashMessage } from '../../utils/flashMessages.utils';
import { ISupportRequestPayload } from '../api/request-config/support.api';

export function* submitSupportRequest(payload: ISupportRequestPayload) {
  const success = (yield call(apiRequest, api.submitSupportRequestApi(payload))) as boolean;
  if (!success) {
    return;
  }

  yield call(dialogService.closeDialog, 'supportDialog');
  yield call(addFlashMessage, { type: 'success', message: 'Your support request has been sent.' });
}
